import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { components } from '@glowforge/ui-common';
import classNames from 'classnames';
import { textPropTypes } from 'app/selectors/support';
import Video from '../video';
import MultiStepTextEntry from './multi-step-text-entry';

import './entries.less';
import './text-entry.less';

const { Markdown } = components;

const TextEntry = ({
  slug,
  title,
  text,
  video,
  media,
  unboxingUpdateEnabled,
  stepNumber,
  multipleSteps,
  steps,
}) => {
  const getAsset = () => {
    if (video && video.length) {
      let src;
      let poster;
      video.forEach((content) => {
        const { contentType, url } = content.fields.file;
        if (contentType === 'video/mp4' || contentType === 'video/quicktime') {
          src = url;
        } else {
          poster = url;
        }
      });
      return <Video key='1' src={src} poster={poster} />;
    }

    if (media) {
      return (
        <img
          src={`${_.get(media, 'fields.file.url')}?w=600`}
          alt={_.get(media, 'fields.file.title')} />
      );
    }
    return null;
  };

  const asset = getAsset();

  return unboxingUpdateEnabled ? (
    <div className='TextEntryUpdated' id={slug}>
      <div className={classNames('textSection', {
        withAsset: asset,
        withTitle: title,
      })}>
        {title && <h3 className='sectionHeader'>{title}</h3>}
        <div className={classNames('textSection', {
          withStep: stepNumber,
        })}>
          {stepNumber && <p className='stepNumber'>{stepNumber}</p>}
          {multipleSteps
            ? <MultiStepTextEntry steps={steps} />
            : <Markdown className='text paragraph' source={text} />}
        </div>
      </div>
      {asset && <div className='mediaSection'>
        {asset}
      </div>}
    </div>
  ) : (
    <div className='TextEntry' id={slug}>
      {title && <h3 className='h2'>{title}</h3>}
      <Markdown className='text paragraph' source={text} />
      {asset}
    </div>
  );
};

TextEntry.propTypes = {
  ...textPropTypes,
  video: PropTypes.arrayOf(...textPropTypes),
  stepNumber: PropTypes.number,
  unboxingUpdateEnabled: PropTypes.bool,
};

TextEntry.defaultProps = {
  video: null,
  stepNumber: null,
  unboxingUpdateEnabled: false,
};

export default TextEntry;



// WEBPACK FOOTER //
// ./app/components/support/entries/text-entry.jsx